import { render, staticRenderFns } from "./DataManagement.vue?vue&type=template&id=0d988b11&scoped=true"
import script from "./DataManagement.vue?vue&type=script&lang=js"
export * from "./DataManagement.vue?vue&type=script&lang=js"
import style0 from "./DataManagement.vue?vue&type=style&index=0&id=0d988b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d988b11",
  null
  
)

export default component.exports